import { render, staticRenderFns } from "./Proceso.vue?vue&type=template&id=1275e202&"
import script from "./Proceso.vue?vue&type=script&lang=js&"
export * from "./Proceso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports